import React from 'react'
import { DatePicker } from 'components/datePicker'
import { Switch } from 'components/switch'
import { useStyles } from './index.css'

const DatePickerRange = ({ useDateFilter, onUseDateFilterChange, since, onSinceChange, until, onUntilChange }) => {
  const classes = useStyles()
  return (
    <div>
      <Switch checked={useDateFilter} onChange={onUseDateFilterChange} />
      <DatePicker disabled={!useDateFilter} value={since} onChange={onSinceChange} />
      <span className={classes.until}><DatePicker disabled={!useDateFilter} value={until} onChange={onUntilChange} /></span>
    </div>
  )
}

export {
  DatePickerRange
}
